module.exports = __webpack_public_path__ + "static/media/برج-خنک-کن-1.54274e29.jpg";